<template>
    <div>
        <div>
            <Titulo :titulo="'Informes - ' + routeName" />
            <div class="margin-informes">
            <p class="mb-5 text-justify">
                <b>Filtro: </b>Ingresar número de cedula y tipo de identificación del cliente.<br>
                <b>Estado Gestion:</b><br>
                <ol start="0">
                    <li>Sin acuerdo de pago</li>
                    <li>En acuerdo de pago</li>
                    <li>Pagada total</li>
                </ol>
            </p>
            <table-component
                :data="data"
                @click-buscar="getInformacionCliente"
                filtro
                showFilterCedula
                :TipoDocumento="TipoDocumento"
                showFilterTipoDocumento
            >
                <table-column
                    :customClass="'text-center'"
                    slot="label"
                    :label="'Tipo documento'"
                    v-bind:value="'tipo_identif'"
                ></table-column>
                <table-column
                    :customClass="'text-center'"
                    slot="label"
                    :label="'Numero documento'"
                    v-bind:value="'cedula'"
                ></table-column>
                <table-column
                    :customClass="'text-center'"
                    slot="label"
                    :label="'Ob. garantizadas'"
                    v-bind:value="'garantias'"
                ></table-column>
                <table-column
                    :customClass="'text-center'"
                    slot="label"
                    :label="'Ob. Pagadas'"
                    v-bind:value="'pagos'"
                ></table-column>
                <table-column
                    :customClass="'text-center'"
                    slot="label"
                    :label="'Estado Gestión'"
                    v-bind:value="'estado_gestion'"
                ></table-column>
            </table-component>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "observador",
    data() {
        return {
            tipo_documento: "",
            documento:"",
            response: []
        };
    },

    components: {
        Titulo: () => import("@/containers/layout/Titulo.vue"),
        TableComponent: () => import("@/components/table/TableComponent"),
        TableColumn: () => import("@/components/table/TableColumn"),
    },

    computed: {
        ...mapGetters({
            // loading: "loading",
        }),
        data() {
            return this.response;
        },
        routeName() {
            return this.$router.currentRoute.name;
        },
        TipoDocumento() {
            let data = [
                { value: null, text: "Tipo Documento", disabled: true },
                { value: "cc", text: "CC"},
                { value: "ce", text: "CE"},
                { value: "nit", text: "NIT"},
                { value: "ti", text: "TI"},
                { value: "nuip", text: "NUIP"},
                { value: "ps", text: "PS"},
                { value: "ppt", text: "PPT"},
                { value: "pep", text: "PEP"}
            ]
            return data;
        },
    },
    methods: {
        getInformacionCliente(params) {
            if(params.cedula == null || params.tipo_documento == null){
                this.$toasted.show(
                    "El campo tipo documento  y cedula no pueden estar vacios",
                    {
                        theme: "toasted-primary",
                        position: "top-right",
                        duration: 5000,
                    }
                );
                return;
            }
            this.tipo_documento = params.tipo_documento;
            this.cedula = params.cedula;
            this.loadData()
        },
        async loadData(row, page, paginar = true) {
            this.$store.commit("SET_LOADING", true);

            const resultado = await this.getDataApi();

            if(resultado){
                let estado_gestion = "";
                for (let index = 0; index < resultado['recuperadas_total']; index++) {
                    if(index == 0 && estado_gestion == ""){
                        estado_gestion += "2"
                    }else{
                        estado_gestion += "-2"
                    }
                }

                for (let index = 0; index < resultado['con_acuerdo_pago']; index++) {
                    if(index == 0 && estado_gestion == ""){
                        estado_gestion += "1"
                    }else{
                        estado_gestion += "-1"
                    }
                }

                for (let index = 0; index < resultado['sin_acuerdo_pago']; index++) {
                    if(index == 0 && estado_gestion == ""){
                        estado_gestion += "0"
                    }else{
                        estado_gestion += "-0"
                    }
                }

                resultado['estado_gestion'] = estado_gestion

                this.response= [resultado]
            }else{
                this.response = [];
                this.$toasted.show(
                    "Cedula no registrada en FGA",
                    {
                        theme: "toasted-primary",
                        position: "top-right",
                        duration: 5000,
                    }
                );
            }
            this.$store.commit("SET_LOADING", false);

        },
        async getDataApi (){
            var axios = require("axios");

            try {
                let data = {
                    "tipo":this.tipo_documento,
                    "cedula":this.cedula
                }

                const config = {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('tokenGateway')}`,
                        'Content-Type': 'application/json'
                    },
                    params: data
                };

                let request = await axios.get("https://sigapi.fga.com.co/api/service/observador",config)
                return request.data.datos;

            } catch (err) {
                this.$toasted.show(
                    "Ocurrió un error en la aplicación al intentar registrar la novedad.",
                    {
                        theme: "toasted-primary",
                        position: "top-right",
                        duration: 5000,
                    }
                );
            }
        }
    }
}
</script>

<style>

</style>